<template lang="pug">
	.handTrackContainer
		canvas#imgCanvas(:width="handTrackConfig.width", :height="handTrackConfig.height", style="display:none")
		template(v-if="debug")
			canvas#debugCanvas
			button.button(@click.prevent="track()") Track
			p Hand Config {{ handTrackConfig }}
			p Predictions {{ predictions }}
</template>

<style lang="scss" scoped>
	//
</style>

<script>
	let handTrackModel;

	export default {
		props: ["handTrackConfig"],
		data() {
			return {
				debug: false, // Set true to draw detection box around hand on a separate canvas
				predictions: [] // Predictions as determined by Handtrack.js
			};
		},
		created() {
			// Load Handtrack.js from CDN since loading it thru NPM/Local doesn't work
			/* global handTrack */
			// https://stackoverflow.com/questions/48426972/importing-javascript-file-for-use-within-vue-component
			const handTrackPlugin = document.createElement("script");
			handTrackPlugin.setAttribute(
				"src",
				"https://cdn.jsdelivr.net/npm/handtrackjs@0.0.13/dist/handtrack.min.js"
			);
			handTrackPlugin.async = true;
			document.head.appendChild(handTrackPlugin);
		},
		methods: {
			// Load the Handtrack Model
			async setup() {
				handTrackModel = await handTrack.load({ maxNumBoxes: 1, scoreThreshold: 0.85 });
				console.log("Handtrack model loaded");
			},
			// Helper function that draws webcam image on canvas (since using image directly doesn't work)
			// https://stackoverflow.com/questions/6011378/how-to-add-image-to-canvas
			drawCanvas() {
				const imgCanvas = document.getElementById("imgCanvas");
				const imgContext = imgCanvas.getContext("2d");

				return new Promise((resolve) => {
					const base_image = new Image();
					base_image.src = this.handTrackConfig.src;
					base_image.onload = () => {
						imgContext.drawImage(base_image, 0, 0);
						resolve();
					};
				});
			},
			// Detect hand
			async track() {
				const imgCanvas = document.getElementById("imgCanvas");

				// Draw webcam image on canvas
				await this.drawCanvas();

				// Detect objects in the image
				this.predictions = await handTrackModel.detect(imgCanvas);
				this.$emit("handDetection", this.predictions.length > 0); // True if a hand detected, false if no hand detected

				// Debug: Draw detection box around hand
				if (this.debug) {
					const debugCanvas = document.getElementById("debugCanvas");
					const debugContext = debugCanvas.getContext("2d");
					handTrackModel.renderPredictions(this.predictions, debugCanvas, debugContext, imgCanvas);
				}
			}
		}
	};
</script>
